import {zodResolver} from "@hookform/resolvers/zod";
import {useForm} from "react-hook-form";
import {useLocation,useNavigate} from "react-router-dom";
import {Input} from "shared/components/inputs/Input";
import {z} from "zod";
import styles from "./CdEndereco.module.scss";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import {buscarEnderecoPorCep} from "shared/services/api/cep.api";
import {criarEndereco} from "shared/services/api/endereco.api";
import {traduzirErro} from "shared/utils/traduzirErro";
import {maskCep} from "shared/utils/masks";
import {useAuth} from "../../shared/contexts/Auth/AuthContext";

const schema=z.object({
  nome:z.string().min(2,"Nome do endereço é obrigatório"),
  cep:z.string().min(8,"CEP inválido"),
  rua:z.string().min(2,"Rua é obrigatória"),
  numero:z.string().min(1,"Número é obrigatório"),
  complemento:z.string().optional(),
  bairro:z.string().min(2,"Bairro é obrigatório"),
  cidade:z.string().min(2,"Cidade é obrigatória"),
  estado:z.string().min(2,"Estado é obrigatório"),
});

type FormData=z.infer<typeof schema>;

interface CadastroLojaState {
  origem?:string;
  returnTo?:string;
  selecionarEndereco?:boolean;
  enderecoId?:string;
  dadosInformacoes?:unknown;
  dadosRepresentante?:unknown;
  dadosEndereco?:unknown;
  abaRetorno?:string;
}

export const CdEndereco=()=>{
  const navigate=useNavigate();
  const location=useLocation();
  const {user}=useAuth();
  const navigationState=location.state as CadastroLojaState|null;

  const {register,handleSubmit,setValue,formState:{errors}}=useForm<FormData>({
    resolver:zodResolver(schema),
    mode:"onBlur",
  });

  const onSubmit=async(data:FormData)=>{
    try{
      const enderecoId=await criarEndereco(data,user?.name||"");

      if(!enderecoId){
        throw new Error("O endereço foi cadastrado, mas a API não retornou o ID.");
      }

      alert("Endereço cadastrado com sucesso!");

      if(navigationState?.origem==="cadastro-loja"&&navigationState.returnTo){
        navigate("/meusenderecos",{
          state:{
            origem:"cadastro-loja",
            returnTo:navigationState.returnTo,
            selecionarEndereco:true,
            enderecoId,
            dadosInformacoes:navigationState.dadosInformacoes,
            dadosRepresentante:navigationState.dadosRepresentante,
            dadosEndereco:navigationState.dadosEndereco,
            abaRetorno:navigationState.abaRetorno??"endereco",
          },
        });
        return;
      }

      navigate("/meusenderecos");
    }catch(error:any){
      alert(traduzirErro(error));
    }
  };

  return(
    <PageContainer title="Cadastrar Endereço" showDesktopSearch={false}>
      <div className={styles.page}>
        <form onSubmit={handleSubmit(onSubmit)} className={styles.card}>
          <div className={styles.containerLabel}>
            <label className={styles.label}>Nome do Endereço</label>
            <Input
              name="nome"
              type="text"
              placeholder="Ex: Casa, Trabalho, Casa da Vó"
              register={register("nome")}
              error={errors.nome?.message}
              customClass={styles.customInput}
            />
          </div>

          <div className={styles.containerLabel}>
            <label className={styles.label}>CEP</label>
            <Input
              name="cep"
              type="text"
              placeholder="Digite o CEP"
              register={register("cep",{
                onChange:async(e)=>{
                  const value=maskCep(e.target.value);
                  e.target.value=value;
                  const cepLimpo=value.replace(/\D/g,"");

                  if(cepLimpo.length===8){
                    const endereco=await buscarEnderecoPorCep(cepLimpo);

                    if(endereco){
                      setValue("rua",endereco.rua);
                      setValue("bairro",endereco.bairro);
                      setValue("cidade",endereco.cidade);
                      setValue("estado",endereco.estado);
                    }
                  }
                },
              })}
              error={errors.cep?.message}
              inputMode="numeric"
              customClass={styles.customInput}
            />
          </div>

          <div className={styles.containerLabel}>
            <label className={styles.label}>Rua</label>
            <Input
              name="rua"
              type="text"
              placeholder="Digite a rua"
              register={register("rua")}
              error={errors.rua?.message}
              customClass={styles.customInput}
            />
          </div>

          <div className={styles.containerLabel}>
            <label className={styles.label}>Número</label>
            <Input
              name="numero"
              type="text"
              placeholder="Número"
              register={register("numero")}
              error={errors.numero?.message}
              customClass={styles.customInput}
            />
          </div>

          <div className={styles.containerLabel}>
            <label className={styles.label}>Complemento</label>
            <Input
              name="complemento"
              type="text"
              placeholder="Apartamento, bloco..."
              register={register("complemento")}
              customClass={styles.customInput}
            />
          </div>

          <div className={styles.containerLabel}>
            <label className={styles.label}>Bairro</label>
            <Input
              name="bairro"
              type="text"
              placeholder="Digite o bairro"
              register={register("bairro")}
              error={errors.bairro?.message}
              customClass={styles.customInput}
            />
          </div>

          <div className={styles.containerLabel}>
            <label className={styles.label}>Cidade</label>
            <Input
              name="cidade"
              type="text"
              placeholder="Digite a cidade"
              register={register("cidade")}
              error={errors.cidade?.message}
              customClass={styles.customInput}
            />
          </div>

          <div className={styles.containerLabel}>
            <label className={styles.label}>Estado</label>
            <Input
              name="estado"
              type="text"
              placeholder="Ex: MG"
              register={register("estado")}
              error={errors.estado?.message}
              customClass={styles.customInput}
            />
          </div>

          <div className={styles.buttons}>
            <button
              type="button"
              className={styles.cancel}
              onClick={()=>navigate(-1)}
            >
              Cancelar
            </button>

            <button type="submit" className={styles.save}>
              Salvar Endereço
            </button>
          </div>
        </form>
      </div>
    </PageContainer>
  );
};